import HeroSection from "./sections/HeroSection";
import ClientLogosSection from "./sections/ClientLogosSection";
import ServicesSection from "./sections/ServicesSection";
import KeyFiguresSection from "./sections/KeyFiguresSection";
import PricingPlansSection from "./sections/PricingPlansSection";
import WorkCarouselSection from "./sections/WorkCarouselSection";
import TestimonialsSection from "./sections/TestimonialsSection";
import TechStackSection from "./sections/TechStackSection";
import ContactSection from "./sections/ContactSection";
import LegalContentSection from "./sections/LegalContentSection";
import PrivacyContentSection from "./sections/PrivacyContentSection";
import SiteHeader from "./sections/SiteHeader";
import SiteFooter from "./sections/SiteFooter";
import ContactConfirmationPage from "./pages/ContactConfirmationPage";
// EXCEPTION ASSUMÉE à l'isolation entre moteurs — voir le commentaire
// détaillé plus bas (SECTION_REGISTRY, product_grid/checkout_form).
import ProductGridSection from "../default/sections/ProductGridSection";
import CheckoutFormSection from "../default/sections/CheckoutFormSection";

// Registre du moteur de thème "agence_v1" — la refonte 2026 du site
// ClickExpert (handoff `ClickExpert.dc.html`), reproduite section par
// section. Doit rester en phase avec le catalogue serveur du MÊME moteur
// (backend/services/theme_engines/agence_v1/sections.py) : le serveur ne
// connaît que le TYPE de chaque section, c'est ici — et seulement ici —
// qu'il se résout en contenu visuel pour CE moteur.
export const SECTION_REGISTRY = {
  hero: { label: "Bandeau principal", Component: HeroSection },
  client_logos: { label: "Bandeau logos clients", Component: ClientLogosSection },
  services: { label: "Services", Component: ServicesSection },
  key_figures: { label: "Chiffres clés", Component: KeyFiguresSection },
  pricing_plans: { label: "Tarifs", Component: PricingPlansSection },
  work_carousel: { label: "Réalisations", Component: WorkCarouselSection },
  testimonials: { label: "Avis clients", Component: TestimonialsSection },
  tech_stack: { label: "Technologies", Component: TechStackSection },
  contact: { label: "Contact", Component: ContactSection },
  // Page partagée par tous les moteurs (backend theme_engines/shared_pages.py).
  legal_content: { label: "Mentions légales", Component: LegalContentSection },
  privacy_content: { label: "Politique de confidentialité", Component: PrivacyContentSection },
  // Le handoff est une landing ONE-PAGE : il ne dit rien de la page
  // Boutique ni du panier. Or /boutique et /panier ne rendent QUE les
  // sections de leur template (voir Catalog.jsx/Checkout.jsx) — sans ces
  // deux entrées, une boutique qui publie ce thème perdrait sa grille de
  // produits et son tunnel de commande.
  //
  // Ce sont donc les DEUX seuls composants empruntés au moteur "default",
  // à l'identique (mêmes noms de type et de champs des deux côtés, voir le
  // catalogue serveur). Un choix délibéré : dupliquer un tunnel de
  // commande — coordonnées, livraison, paiement Stripe — pour de simples
  // raisons d'isolation reviendrait à en maintenir deux copies, avec le
  // risque qu'une correction n'atterrisse que dans l'une des deux. Ils
  // suivent la palette et la typographie de la boutique, donc s'accordent
  // déjà au reste du thème.
  product_grid: { label: "Grille de produits", Component: ProductGridSection },
  checkout_form: { label: "Formulaire de commande", Component: CheckoutFormSection },
};

// Couche d'EXTENSION des sections PARTAGÉES (importées des autres moteurs
// sous leur type préfixé — voir themes/shared.js) : pour adapter une section
// importée à la particularité de CE moteur, y déclarer un composant qui
// remplace ou enveloppe celui d'origine, ex. :
//
//   import AgenceHero from "../agence_v1/sections/HeroSection";
//   const HeroPourIci = (p) => <div className="…"><AgenceHero {...p} /></div>;
//   export const SHARED_EXTENSIONS = { agence_hero: { Component: HeroPourIci, label: "…" } };
//
// Le pendant serveur (textes par défaut, champs, pages, libellé) est
// `shared_overrides` du CATALOG du moteur (backend theme_engines/<moteur>/).
export const SHARED_EXTENSIONS = {};

export const DEFAULT_SECTION_ORDER = [
  "hero", "client_logos", "services", "key_figures",
  "pricing_plans", "work_carousel", "testimonials", "tech_stack", "contact",
];

// En-tête et pied de page — contrairement au moteur "default", dont le
// chrome vit en JSX codé en dur dans components/Header.jsx et
// components/Footer.jsx, ce moteur les rend lui-même : le handoff a un
// en-tête et un pied de page qui lui sont propres, et l'utilisateur les a
// demandés au même titre que le contenu. Un moteur qui ne déclare pas
// CHROME garde le chrome partagé, inchangé (voir themes/registry.js).
export const CHROME = {
  Header: SiteHeader,
  Footer: SiteFooter,
};

// Pages hors sections — même principe que CHROME : la confirmation d'envoi
// du formulaire de contact reprend le langage visuel du handoff plutôt que
// la page générique du moteur "default" (voir themes/registry.js).
export const PAGES = {
  contact_confirmation: ContactConfirmationPage,
};

// Pages de SECTIONS du moteur : chemin public → template (voir
// pages/EnginePage.jsx). Ce moteur n'a que la page PARTAGÉE par tous les
// moteurs — la politique de confidentialité, miroir de PAGES dans
// backend/services/theme_engines/agence_v1/sections.py (shared_pages.py).
// `seoKey` est la clé de Gestion SEO, `title`/`description` le repli tant
// que l'admin n'y a rien saisi.
export const ROUTES = {
  // Pages PARTAGÉES par tous les moteurs (backend theme_engines/shared_pages.py) :
  // mentions légales et politique de confidentialité, gérées par thème.
  "/mentions-legales": {
    template: "legal",
    seoKey: "mentions-legales",
    title: "Mentions légales",
    description: "Informations légales, données personnelles et cookies.",
  },
  "/confidentialite": {
    template: "privacy",
    seoKey: "confidentialite",
    title: "Politique de confidentialité",
    description: "Comment nous utilisons vos données de navigation pour améliorer le site.",
  },
};
